/* unplugin-vue-components disabled */import script from "./emailDiv.vue?vue&type=script&setup=true&lang=js"
export * from "./emailDiv.vue?vue&type=script&setup=true&lang=js"

import "./emailDiv.vue?vue&type=style&index=0&id=a3055586&scoped=true&lang=css"

import exportComponent from "D:\\00JH-项目\\钧舵机器人\\cn\\jodell_robotics\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3055586"]])

export default __exports__